import { render } from "./PopupNotification.vue?vue&type=template&id=43125ac0&ts=true"
import script from "./PopupNotification.vue?vue&type=script&lang=ts"
export * from "./PopupNotification.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__